import { CommunitiesState, RootState } from './state_models'

import { ActionContext } from 'vuex/types/index.js'
import { LocationCommunity } from '../models/communities'
import { Module } from 'vuex'

export const communities: Module<CommunitiesState, RootState> = {
  namespaced: true,
  state: { locationData: {}, usersData: {}, groups: [] , locationId: ''},
  getters: {
    getLocationData: (state: CommunitiesState) => {
      return state.locationData
    },
    getUsersData: (state: CommunitiesState) => {
      return state.usersData
    },
    getGroups: (state: CommunitiesState) => {
      return state.groups
    },

  },
  mutations: {
    setLocationData(state, value) {
      state.locationData = value
    },
    setUsersData(state, value) {
      state.usersData = value
    },
    setGroups(state, value) {
      state.groups = value
    },
    setLocationId(state, value) {
      state.locationId = value
    },
    clearAll(state) {
      state.locationData = {}
      state.usersData = {}
      state.groups = []
    },
  },
  actions: {
    async syncAll(
      context: ActionContext<CommunitiesState, RootState>,
      params: { locationId: string; forceRefresh?: boolean }
    ) {
      console.log('syncAll for communities', params)
      if (!params || !params.locationId) {
        context.commit('clearAll')
        return
      }

      const locationId = params.locationId

      if (!params.forceRefresh && context.state.locationId === locationId) return
      context.commit('setLocationId', params.locationId)

      context.commit('clearAll')

      const communities = await LocationCommunity.fetchAllActiveGroups(locationId)
      if (context.state.locationId === locationId) {
        // some other call may have changed locationid
         context.commit(
           'setGroups',
           communities.groups.map(a => ({ key: a._id, value: a.name }))
         )
         
      }
    },
  },
}